// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"W2-z","dimensionLabel":"X2-z","styleChooserControlWrapper":"Y2-z","styleChooserControl":"Z2-z","disabled":"_2-z","giftCard":"a3-z","styleChooserText":"b3-z"};